<app-alert></app-alert>
<div class="row">
    <div class="col-sm-12 col-md-4">
        <hr>
    </div>
    <div class="col-sm-12 col-md-4 align-center">
        <legend>Dance</legend>
    </div>
    <div class="col-sm-12 col-md-4">
        <hr>
    </div>
</div>
<br>


<div class="row">
    <div class="col-xs-12 padding-left-and-right text-justify text-add-line-height">
        I have always had a life long passion for dancing. I would say I am a dancer of all trades
        and master of none. What I mean by that is that I have studied and trained in all types of
        dance but not really an expert in any of them. Some people have a passion for a specific type of
        dance but I enjoy all types of dancing and each dance allows me to express myself in
        a different way.
        <br><br>
        I originally started out swing dancing and I was competing and training in Lindy Hop and
        Hollywood Swing. I had some exciting opportunities come up and I ended up swing dancing
        in in the "Choice of the Century" commercial for WDIV TV/Channel 4 and and was a finalist in WDIV's Super
        Dancer Contest.
        <br><br>
        Shortly after starting swing dancing, I started to learn to dance salsa. I competed and trained in salsa
        for quite some time and performed in several Salsa Congress's and also performed for the Detroit Greek Town
        Casino
        in the “Sensuality Show” and in the Motown Music Festival. In addition, I competed and
        and placed in the top 10 in the world salsa championships.
        <br><br>
        My enjoyment for dance did not end after learning salsa and swing. I had a strong desire to learn to
        dance International Latin, so I finally started training and competing in International Latin. I
        danced as a Pro/Am student for some time and had taken first place in many Pro/Am International
        Competitions throughout the United States. Eventually, I imported
        a dance partner from Poland and we competed nationally and we took first place in Open Amateur Latin at the
        California Star Ball. In addition to that, my partner and I placed 18th in the USA Open Amateur Latin
        Championships.
        <br><br>
        After dancing Latin, I went back to dancing and training in salsa. For a few years I competed as a
        Pro/Am teacher in Salsa and took 1st place in the 2015
        2015 Latin Street Championship and 3rd place in the 2017 Pro/Open May I Have this Dance competition.
        <br><br>
        In addition to ballroom, I also studies Jazz, Ballet, Contemporary and Hip Hop. I have studied at Hubbard Street
        Dance, Joel Hall Dance Center, Visceral Dance and Contemporary Ballet of Dallas. I really feel like I have a
        lifelong passion
        for dancing and that I can express myself in many ways through each type of dance.
        <br><br>
        Dance is the hidden language of the soul of the body - Martha Graham
    </div>
</div>
<br>
<br>
<div class="row padding-left-and-right">
    <div class="col-sm-12 col-md-4 card-background">
        <div class="card">
            <div class="card-block card-padding ">
                <p class="card-text">
                    <small> <img
                            src="/assets/img/dance/urbanJenny.jpg"
                            class='img-fluid float-right'
                            alt="Latin Fever Jenny"
                        ></small>
                </p>
            </div>
        </div>
    </div>
    <div class="col-sm-12 col-md-4 card-background">
        <div class="card">
            <!-- <img class="card-img-top" src="..." alt="Image Coming Soon">-->
            <div class="card-block card-padding ">
                <p class="card-text">
                    <small> <img
                            src="/assets/img/dance/jennyRoman4.jpg"
                            class='img-fluid float-right'
                            alt="Samba"
                        ></small>
                </p>
            </div>
        </div>
    </div>
    <div class="col-sm-12 col-md-4 card-background">
        <div class="card">

            <div class="card-block card-padding ">
                <p class="card-text">
                    <small> <img
                            src="/assets/img/dance/jennyRoman1.jpg"
                            class='img-fluid float-right'
                            alt="Jenny and Roman Latin"
                        ></small>
                </p>
            </div>
        </div>
    </div>
  
</div>
<br>

    



    


